var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 24C26 28.9706 21.9706 33 17 33C12.0294 33 8 28.9706 8 24C8 19.0294 12.0294 15 17 15C21.9706 15 26 19.0294 26 24ZM23.9998 32.4858C22.098 34.0564 19.6592 35 17 35C10.9249 35 6 30.0751 6 24C6 17.9249 10.9249 13 17 13C19.6592 13 22.098 13.9436 23.9998 15.5142C25.9017 13.9436 28.3404 13 30.9996 13C37.0747 13 41.9996 17.9249 41.9996 24C41.9996 30.0751 37.0747 35 30.9996 35C28.3404 35 25.9017 34.0564 23.9998 32.4858ZM25.4284 31.0688C26.9608 32.2782 28.8959 33 30.9996 33C35.9702 33 39.9996 28.9706 39.9996 24C39.9996 19.0294 35.9702 15 30.9996 15C28.8959 15 26.9608 15.7218 25.4284 16.9312C27.0334 18.8429 28 21.3086 28 24C28 26.6914 27.0334 29.1571 25.4284 31.0688Z",
    fill: "#ADADAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.f95c0c19eb6c2f429bc2ac98a744f1c7.svg";
export { ForwardRef as ReactComponent };